import React, {useState} from 'react';
import {makeStyles, withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {InputAdornment, useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";
import {theme} from "../../../config/design/theme";
import {MapPin,Heart,Home,BriefcaseBusiness} from "lucide-react";


const AddressIcon = ({icon}) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {
                icon === "map-pin" ?
                    <MapPin/>
                    :
                    icon === "partner" ?
                        <Heart/>
                        :
                            icon === "work" ?
                                <BriefcaseBusiness/>
                                :
                                    icon === "home" ?
                                        <Home/>
                                        :
                                            <MapPin/>
            }
        </>
    );
};

export default withStyles(Styles)(AddressIcon);
